
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local';

i18n
  .use(initReactI18next)
  .init({
    resources: messages,
    lng: 'zh', // 默认语言设置为中文
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
